import React, { useMemo, useState } from 'react';
import AdvancedFilters, { buildRansackSearch } from '@/components/admin/SysadminSPA/shared/AdvancedFilters';
import type { InitialFilter } from '@/components/admin/SysadminSPA/shared/AdvancedFilters';
import type { RansackSearch } from '@/components/admin/SysadminSPA/shared/filterTypes';
import SPADataTable from '@/components/admin/SysadminSPA/shared/SPADataTable';
import useFilterSearchParams from '@/components/admin/SysadminSPA/shared/useFilterSearchParams';
import getAlertMessageColumns from './alertMessageColumns';
import useContentAlertMessages from './useContentAlertMessages';
import useFilterOptions from './useFilterOptions';

// The legacy page opened on its "Program Specific" tab; the same default here is a Scope filter.
const DEFAULT_FILTERS: InitialFilter[] = [
  { operator: 'eq', property: 'kind', value: 'program' },
];

const toRows = (filters: InitialFilter[]) => (
  filters.map((f, i) => ({ id: i, operator: f.operator, property: f.property, value: f.value ?? '' }))
);

const AlertMessagesTable = () => {
  const { initialFilters, syncRowsToURL } = useFilterSearchParams();
  const filtersToUse = initialFilters.length > 0 ? initialFilters : DEFAULT_FILTERS;
  const initialSearch = useMemo(() => buildRansackSearch(toRows(filtersToUse)), []); // eslint-disable-line
  const [ransackSearch, setRansackSearch] = useState<RansackSearch>(initialSearch);
  const { data, totalCount, isLoading, isFullyLoaded } = useContentAlertMessages(ransackSearch);
  const filterProperties = useFilterOptions();

  return (
    <div className="tw-mt-4">
      <AdvancedFilters
        clearFilters={DEFAULT_FILTERS}
        initialFilters={filtersToUse}
        properties={filterProperties}
        onFilterChange={setRansackSearch}
        onRowsChange={syncRowsToURL}
      />

      <SPADataTable
        columns={getAlertMessageColumns()}
        data={data}
        emptyMessage="No alert messages match these filters."
        isLoading={isLoading}
        loadingRows={20}
        loadingStatus={{ isFullyLoaded, loadedCount: data.length, totalCount }}
        pagination={{ defaultPageSize: 20, pageSizeOptions: [10, 20, 50, 100] }}
      />
    </div>
  );
};

export default AlertMessagesTable;
